// Import translation
import i18n from 'i18next';

export default ({ phone_number }) => {
	let errors = {};

	if (!phone_number) {
		errors.phone_number = i18n.t(
			'common_login_firebase_phone_number_validation'
		);
	}

	return errors;
};
